import { createStyles, makeStyles } from '@material-ui/core/styles'
import { uniqBy } from 'lodash'
import { useEffect, useState } from 'react'
import { Loading } from 'react-admin'

import { getZendeskTickets } from '../../api/zendesk'
import { offsetDateInDays } from '../../helpers/dateHelpers'
import { ZendeskTickets } from '../Zendesk/ZendeskTickets'

interface JobZendeskTicketsProps {
  job: any
}

const useStyles = makeStyles(() =>
  createStyles({
    loading: {
      height: 'auto',
      marginTop: '50px',
    },
  })
)

export function JobZendeskTickets({ job }: JobZendeskTicketsProps) {
  // Dummy data, uncomment to test in dev
  // job.human_id = 'G8VA-T3C8'
  // job.load.source_human_id = 'LD17054'
  // job.date_created = '2021-11-30T12:08:01-08:00'
  // if (job.team?.members && job.team?.members[0]) {
  //   job.assigned_to.id = job.team.members[0].id
  //   job.team.members[0].email = 'javonjohnsonc4@hotmail.com'
  // }

  const styles = useStyles()
  const [loading, setLoading] = useState(true)
  const [tickets, setTickets] = useState<any>([])
  const user = job.team?.members?.find((member: any) => member.id === job.assigned_to?.id)

  useEffect(() => {
    job.human_id &&
      getZendeskTickets({
        query: job.human_id,
      }).then((data: any) => {
        setTickets((tickets: any) => [...tickets, ...data.tickets])
        setLoading(false)
      })
    // Only search by job load id if its not numeric to prevent false positives
    job.load?.source_human_id &&
      isNaN(Number(job.load?.source_human_id)) &&
      getZendeskTickets({
        query: job.load?.source_human_id,
      }).then((data: any) => {
        setTickets((tickets: any) => [...tickets, ...data.tickets])
        setLoading(false)
      })
  }, [job.human_id, job.load?.source_human_id])

  useEffect(() => {
    if (user?.email) {
      getZendeskTickets({
        email: user.email,
        created_after: offsetDateInDays(job.date_created, -1),
        created_before: offsetDateInDays(job.date_created, 2),
      }).then((data: any) => {
        setTickets((tickets: any) => [...tickets, ...data.tickets])
        setLoading(false)
      })
    }
  }, [user?.email, job.date_created])

  if (loading) {
    return <Loading className={styles.loading} />
  }

  return <ZendeskTickets tickets={uniqBy(tickets, 'id')} />
}
